export const FirebaseConfig = {
	"projectId": "med-lift-bxr277",
	"appId": "1:15506508684:web:903186f342bc707f0064a9",
	"databaseURL": "https://med-lift-bxr277-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "med-lift-bxr277.appspot.com",
	"locationId": "europe-west6",
	"apiKey": "AIzaSyDp72No0OzEilQqRORpTSdRBkyn2pxfrgk",
	"authDomain": "med-lift-bxr277.firebaseapp.com",
	"messagingSenderId": "15506508684",
	"projectNumber": "15506508684",
	"version": "2"
};

export const ChatApiKey = "m6rwyeff28v7";